import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IBaseModel } from 'src/app/models/base.model';
import { ICapituloRelatorioModel } from 'src/app/models/capitulo-relatorio.model';
import { IEnumModel } from 'src/app/models/enum.model';
import { CapituloRelatorioService } from 'src/app/services/capitulo-relatorio.service';
import { TabelaDominioService } from 'src/app/services/tabela-dominio.service';
import { BaseFormComponent } from '../../shared/components/base-form/base-form.component';


@Component({
  selector: 'app-capitulo-relatorio-form',
  templateUrl: './capitulo-relatorio-form.component.html',
  styleUrls: ['./capitulo-relatorio-form.component.scss']
})
export class CapituloRelatorioFormComponent extends BaseFormComponent implements OnInit {
  public model: ICapituloRelatorioModel = {} as ICapituloRelatorioModel;
  public enumTipo = [] as IEnumModel[];

  public form = new FormGroup({
    id: new FormControl({ value: '', disabled: true }),
    nome: new FormControl('', Validators.required),
    tipoId: new FormControl(null, Validators.required),
    conteudo: new FormControl('', Validators.required),
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private tabelaDominioService: TabelaDominioService,
    private capituloRelatorioService: CapituloRelatorioService,
    public matDialog: MatDialog
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.novoRegistro) {
      this.titulo = 'Novo Capitulo de Relatório';
    } else {
      this.titulo = 'Editar Capitulo de Relatório #' + this.id;
    }
  }

  async ngOnInit() {
    try {
      if (!this.novoRegistro) {
        const res = await this.capituloRelatorioService.obterPorId(this.id);
        if (res.sucesso) {
          this.model = res.dados;
        } else {
          this.toastr.error(res.mensagem.descricao, 'Atenção');
          this.router.navigate(['/capitulos-relatorio']);
          return;
        }
      }

      await this.tabelaDominioService.obterTipoCapituloRelatorio().then((res) => this.enumTipo = res.dados),

        this.form.patchValue(this.model);
    } catch (err) {
      this.toastr.error(err.mensagem.descricao, 'Atenção');
      this.router.navigate(['/capitulos-relatorio']);
    } 
  }

  public async onSubmit() {
    if (this.form.invalid) {
      this.toastr.warning('Formulário inválido!', 'Atenção');
      return;
    }

    this.atualizarModel(this.form.value);

    try {
      let res: IBaseModel<void> = null;

      if (!this.novoRegistro) {
        res = await this.capituloRelatorioService.atualizar(this.model);
      } else {
        res = await this.capituloRelatorioService.inserir(this.model);
      }

      if (res.sucesso) {
        this.toastr.success(res.mensagem.descricao, 'Sucesso');
        this.router.navigate(['/capitulos-relatorio']);
      } else {
        const validacoes = this.montarMensagensValidacao(res);

        this.toastr.warning(validacoes, res.mensagem.descricao);
      }
    } catch (err) {
      this.toastr.error(err.mensagem.descricao, 'Atenção');
    } 
  }

  private atualizarModel(values: any) {
    Object.assign(this.model, values);
  }

  public onBack() {
    this.router.navigate(['/capitulos-relatorio']);
  }
}
